<template>
    <div class="bg-white d-flex-between-center p-x-20 p-y-8" @click="openModal">
        <div class="f-12 nomore">
            <span class="f-semi f-c-midgrey">Tampilkan: </span>
            <span class="f-regular f-c-blue" v-if="number === '' && deviceName === ''">Semua perangkat</span>
            <span class="f-regular f-c-blue" v-else>
                <span class="wa-number">
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M8.0267 1.33354C4.3867 1.33354 1.42003 4.3002 1.42003 7.9402C1.42003 9.10687 1.7267 10.2402 2.30003 11.2402L1.3667 14.6669L4.8667 13.7469C5.83337 14.2735 6.92003 14.5535 8.0267 14.5535C11.6667 14.5535 14.6334 11.5869 14.6334 7.94687C14.6334 6.1802 13.9467 4.5202 12.7 3.27354C12.0888 2.65615 11.3608 2.16665 10.5585 1.83357C9.75609 1.50049 8.89544 1.33051 8.0267 1.33354ZM8.03337 2.44687C9.50003 2.44687 10.8734 3.0202 11.9134 4.0602C12.4238 4.57044 12.8284 5.17641 13.1041 5.84338C13.3798 6.51034 13.5212 7.22517 13.52 7.94687C13.52 10.9735 11.0534 13.4335 8.0267 13.4335C7.04003 13.4335 6.07337 13.1735 5.23337 12.6669L5.03337 12.5535L2.95337 13.1002L3.5067 11.0735L3.37337 10.8602C2.82266 9.98598 2.53137 8.97342 2.53337 7.9402C2.54003 4.91353 5.00003 2.44687 8.03337 2.44687ZM5.6867 4.88687C5.58003 4.88687 5.40003 4.92687 5.2467 5.09354C5.10003 5.2602 4.6667 5.66687 4.6667 6.47354C4.6667 7.28687 5.26003 8.06687 5.33337 8.1802C5.4267 8.29353 6.5067 9.9602 8.1667 10.6669C8.56003 10.8469 8.8667 10.9469 9.1067 11.0202C9.50003 11.1469 9.86003 11.1269 10.1467 11.0869C10.4667 11.0402 11.12 10.6869 11.26 10.3002C11.4 9.91353 11.4 9.58687 11.36 9.51353C11.3134 9.44687 11.2067 9.40687 11.04 9.33353C10.8734 9.2402 10.06 8.8402 9.91336 8.78687C9.76003 8.73353 9.6667 8.70687 9.54003 8.86687C9.43336 9.03353 9.11337 9.40687 9.02003 9.51353C8.92003 9.62687 8.8267 9.6402 8.6667 9.5602C8.49337 9.47353 7.96003 9.3002 7.33337 8.7402C6.84003 8.3002 6.51337 7.7602 6.41337 7.59353C6.33337 7.43353 6.4067 7.33353 6.4867 7.2602C6.56003 7.18687 6.6667 7.06687 6.73337 6.96687C6.82003 6.87353 6.8467 6.8002 6.90003 6.69353C6.95337 6.5802 6.9267 6.48687 6.8867 6.40687C6.8467 6.33353 6.51337 5.50687 6.37337 5.1802C6.24003 4.8602 6.1067 4.9002 6.00003 4.89354C5.9067 4.89354 5.80003 4.88687 5.6867 4.88687Z"
                            fill="#206CFF"
                        />
                    </svg>
                    {{ number }}
                </span>
                <span>
                    {{ deviceName }}
                </span>
            </span>
        </div>
        <div class="">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M4.4107 6.91058C4.73614 6.58514 5.26378 6.58514 5.58922 6.91058L9.99996 11.3213L14.4107 6.91058C14.7361 6.58514 15.2638 6.58514 15.5892 6.91058C15.9147 7.23602 15.9147 7.76366 15.5892 8.08909L10.5892 13.0891C10.2638 13.4145 9.73614 13.4145 9.4107 13.0891L4.4107 8.08909C4.08527 7.76366 4.08527 7.23602 4.4107 6.91058Z"
                    fill="#206CFF"
                />
            </svg>
        </div>
    </div>
</template>

<script>
export default {
    name: "FilterStatusWA",
    props: {
        number: {
            default: "",
            type: String,
        },
        deviceName: {
            default: "",
            type: String,
        },
        openModal: {
            type: Function,
            required: true,
        },
    },
};
</script>

<style scoped>
.wa-number {
    border: 1px solid #ededed;
    border-radius: 4px;
    padding: 2px 4px;
    margin-left: 4px;
}
</style>
